import { HeroCtaView } from "@softmax/product-ux/editor";
import { TrackedLink } from "@softmax/web-features/telemetry";
import { analyticsEvents } from "@softmax/web-features/telemetry/events";
import { ctaLabelMaxCharacters } from "../store-page/content-limits";
import { useEditModeMaybe } from "../use-edit-mode-maybe";
import { EditableField } from "./editable-field";

export function HeroCta({
  doorHref,
  previewSlug,
  isMember,
  liveLabel,
  memberLabel = "Your play page",
  large,
}: {
  large?: boolean | undefined;
  doorHref: string;
  previewSlug: string;
  isMember: boolean;
  liveLabel: string;
  /** What a member's door says. */
  memberLabel?: string | undefined;
}) {
  const mode = useEditModeMaybe();
  const label = isMember ? memberLabel : liveLabel;

  if (!mode?.editing)
    return (
      <HeroCtaView
        large={large}
        editing={false}
        renderLink={(props) => (
          <TrackedLink
            {...props}
            href={doorHref}
            analyticsEvent={analyticsEvents.previewCtaClicked}
            analyticsProperties={{ coworld: previewSlug, isMember }}
          />
        )}
      >
        {label}
      </HeroCtaView>
    );

  if (isMember)
    return (
      <HeroCtaView editing large={large}>
        {label}
      </HeroCtaView>
    );

  const { editor } = mode;
  return (
    <HeroCtaView editing large={large}>
      <EditableField
        tag="span"
        value={editor.content.cta_label}
        liveValue={liveLabel}
        onChange={(value) => editor.updateContent({ cta_label: value || null })}
        maxLength={ctaLabelMaxCharacters}
        ariaLabel="Edit CTA label"
        variant="cta"
        lintWarnings={editor.lintWarnings.filter(
          (warning) => warning.field === "cta_label",
        )}
      />
    </HeroCtaView>
  );
}
